import { SlideLayout } from '@gripp/shared-ui';
import React from 'react';
import { SettingColumns } from './settingColumns';

export const Settings: React.FC = () => {
  return (
    <SlideLayout 
      columns={SettingColumns} 
    />
  );
};